<template>
    <div v-show="options.status" 
        :id="ID" ref="colorbar" 
        class="colorbar"
        :class="{ 'colorbar-en': this.language === 'en' }"
    >
        <div class="colorbar-header">
            <div
                v-if="help_msg"
                :class="{ active: is_show_help_msg }"
                class="colorbar-help-btn"
                @mouseover="is_show_help_msg = true"
                @mouseout="is_show_help_msg = false"
            >
                ?
                <div class="colorbar-help-msg">{{ help_msg }}</div>
            </div>
            <div class="colorbar-title">{{ title }}</div>
            <div class="colorbar-unit">{{ unit }}</div>
        </div>
        <div class="colorbar-content">
            <div class="colorbar-cursor"></div>
            <div class="colorbar-color-item">
                <div
                    v-for="(color, lv) in color_list"
                    :key="lv"
                    class="colorbar-color"
                    :class="{ active: color_status[lv], 'cursor-color': cursor_lv === lv }"
                    :style="'background-color:' + color"
                    @click="toggle_color(lv)"
                ></div>
            </div>
            <div class="colorbar-value-item" :class="['colorbar-value-item-' + val_align]">
                <div v-for="(val, lv) in val_list" :key="lv" class="colorbar-value">
                    <span>{{ val }}</span>
                </div>
            </div>
        </div>
        <div class="colorbar-footer">
            <div v-for="(item, key) in cursor_list" :key="key" class="colorbar-cursor-item">
                <span class="colorbar-cursor-title">{{ item.title }}</span>
                <span class="colorbar-cursor-value" :style="'width:' + cursor_val_width + 'em;'">
                    {{ cursor_val[key] ? cursor_val[key] : '--' }}</span
                >
                <span class="colorbar-cursor-unit">{{ item.unit }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'colorbar',
    props: ['options', 'draggable'],
    data: function() {
        return {
            version: '1.0.0', //2021/01/14
            ID: 'colorbar-' + this.options.name,
            title: this.options.setting.title || '',
            unit: this.options.setting.unit || '',
            floating_number: this.options.setting.floating_number || 0,
            color_list: this.options.setting.color_list,
            color_status: [],
            val_list: [],
            val_align: this.options.setting.val_align || 'bottom',
            cursor_list: this.options.setting.cursor_list,
            cursor_val: [],
            cursor_lv: null,
            is_show_help_msg: false, //是否顯示幫助訊息
        }
    },
    computed: {
        ...mapState([
            'language',
        ]),

        help_msg: function() {
            if (this.options.setting.help_msg === undefined) {
                return this.$t('__legend_color_bar_tool.color_bar_hint')
            }

            return this.options.setting.help_msg
        },
        cursor_val_width: function() {
            if (this.options.setting.cursor_width) {
                return this.options.setting.cursor_width
            }

            const max_val = this.val_list[this.val_list.length - 1]
            const max_val_length = String(max_val).length
            return max_val_length / 2 + 1
        },
    },
    beforeMount: function() {
        if (this.options.setting.color_status) {
            this.color_status = this.options.setting.color_status
        } else {
            this.color_status = this.color_list.map((o) => {
                return true
            })
        }

        this.val_list = this.options.setting.val_list.map((val) => {
            if (this.options.setting.val_callback) return this.options.setting.val_callback(val)
            return Number(val).toFixed(this.floating_number)
        })
    },
    mounted: function() {
        if (this.draggable) {
            $(this.$refs['colorbar']).draggable({
                containment: 'parent',
            })
        }

        if (this.options.callback) {
            this.options.callback()
        }

        // 不知道為什麼 id_371_vor 和 id_371_div 的 title 進不來，所以在此例外處理
        if (this.options.name == 'id_371_vor') {
            this.title = 'RWRF vor';
        }
        else if (this.options.name == 'id_371_div') {
            this.title = 'RWRF div';
        }
    },
    methods: {
        toggle_color: function(lv, status) {
            const lv_status = status !== undefined ? status : !this.color_status[lv]
            this.color_status.splice(lv, 1, lv_status)

            if (this.options.switch) {
                this.options.switch(lv, this.color_status)
            }
        },
        change_cursor: function(lv, data_list) {
            this.cursor_lv = lv
            this.cursor_val = data_list.map((val) => {
                if (!val) {
                    return null
                }
                return val.toFixed(this.floating_number)
            })
        },
    },
    watch: {},
}
</script>

<style scoped>
.colorbar {
    position: relative;
    width: fit-content;
    max-height: calc(100% - 7em);
    margin: 0.5em 0;
    padding: 0.4em 0.5em;
    bottom: 8.5em;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.7);
    border: 0.063em solid rgba(0, 0, 0, 0.2);
    border-radius: 0.25em;
    font-family: monospace, 微軟正黑體;
    font-size: 0.875em;
    overflow-y: auto;
}

@media only screen and (max-width: 767px) {
    .colorbar {
        bottom: 10.5em;
    }
}

.colorbar-en {
    overflow-y: visible;
}

.colorbar::-webkit-scrollbar {
    width: 0.4em;
}
.colorbar::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.7);
    -ms-border-radius: 0.2em;
    -moz-border-radius: 0.2em;
    -webkit-border-radius: 0.2em;
    border-radius: 0.2em;
}

.colorbar .colorbar-header {
    margin-right: 1em;
}

.colorbar .colorbar-header .colorbar-help-btn {
    position: absolute;
    width: 1em;
    height: 1em;
    top: 0;
    right: 0;
    border: 0.063em solid #fff;
    border-radius: 0.25em;
    line-height: 1em;
    text-align: center;
    font-family: sans-serif;
    opacity: 0.5;
    cursor: help;
}
.colorbar .colorbar-header .colorbar-help-btn.active {
    opacity: 1;
}

.colorbar .colorbar-header .colorbar-help-btn .colorbar-help-msg {
    position: absolute;
    padding: 0.5em 0.4em;
    top: 1em;
    right: 0;
    color: #333;
    background-color: #eee;
    border: 0.063em solid #333;
    border-radius: 0.25em;
    box-shadow: 0 0 0.5em #333;
    z-index: 2;
    max-height: 16em;
    overflow-y: auto;
    display: none;
}
.colorbar .colorbar-header .colorbar-help-btn.active .colorbar-help-msg {
    display: block;
}

.colorbar-en .colorbar-help-msg {
    left: 0;
    right: unset;
    width: max-content;
}

.colorbar .colorbar-help-msg::-webkit-scrollbar {
    width: 0.4em;
}
.colorbar .colorbar-help-msg::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.5);
    -ms-border-radius: 0.2em;
    -moz-border-radius: 0.2em;
    -webkit-border-radius: 0.2em;
    border-radius: 0.2em;
}

.colorbar .colorbar-header .colorbar-unit {
    margin: 0.3em 0.5em 0 0.5em;
}

.colorbar .colorbar-content {
    display: flex;
    margin: 0.1em 0.5em 1em 0.5em;
}

.colorbar .colorbar-content .colorbar-color-item > div,
.colorbar .colorbar-content .colorbar-value-item > div {
    height: 1rem;
    width: 1.4rem;
}

/* 色塊 */
.colorbar .colorbar-content .colorbar-color-item {
    display: flex;
    flex-direction: column-reverse;
    border: 0.15em solid rgba(255, 255, 255, 0.9);
    border-radius: 1em;
}

.colorbar .colorbar-content .colorbar-color-item .colorbar-color {
    position: relative;
    cursor: pointer;
}
.colorbar .colorbar-content .colorbar-color-item .colorbar-color:not(.active) {
    opacity: 0.1;
}
.colorbar .colorbar-content .colorbar-color-item .colorbar-color:first-child {
    border-radius: 0 0 50% 50%;
}
.colorbar .colorbar-content .colorbar-color-item .colorbar-color:last-child {
    border-radius: 50% 50% 0 0;
}
.colorbar .colorbar-content .colorbar-color-item .colorbar-color::before {
    content: '';
    display: none;
    position: absolute;
    top: 0.4em;
    left: -0.6em;
    border: 0.3em solid transparent;
    border-left: 0.3em solid #fff;
}

/* cursor色塊 */
.colorbar .colorbar-content .colorbar-color-item .colorbar-color.cursor-color.active {
    border-radius: 0.126em;
    box-shadow: 0 0 0 0.063em #fff;
    transform: scale(1.2);
    z-index: 1;
}
.colorbar .colorbar-content .colorbar-color-item .colorbar-color.cursor-color::before {
    display: block;
}

/* 色塊數值 */
.colorbar .colorbar-content .colorbar-value-item {
    display: flex;
    flex-direction: column-reverse;
    margin-top: 0.126em; /* 同色塊border大小 */
    margin-left: 0.3em;
}

.colorbar .colorbar-content .colorbar-value-item .colorbar-value {
    white-space: nowrap;
    line-height: 1.8rem;
}

.colorbar .colorbar-content .colorbar-value-item.colorbar-value-item-middle .colorbar-value {
    line-height: 1.4em;
}

.colorbar .colorbar-content .colorbar-value-item .colorbar-value > span {
    font-size: 0.9em;
}

/* cursor */
.colorbar .colorbar-footer .colorbar-cursor-item .colorbar-cursor-value {
    display: inline-block;
    text-align: right;
    margin: -0.25em;
}
.colorbar .colorbar-footer .colorbar-cursor-item .colorbar-cursor-unit {
    font-size: 0.9em;
}
</style>
